// extracted by mini-css-extract-plugin
module.exports = {"shimmerBox":"shimmer-box_shimmerBox__XMYyy","background-shimmer":"shimmer-box_background-shimmer__4idur"};